import React, { useEffect } from 'react'
import RpaClaimSubmitButton from '../../../../claimForm/submitClaim/RpaClaimSubmitButton'
import { connect, useDispatch } from 'react-redux'
import EyeMedStepForm from './EyeMedStepForm'
import { reduxForm } from 'redux-form'
import ScrollToTarget from '../../../../../../../../../itrust_common/components/others/ScrollToTarget'
import ClaimFormOverview from '../ClaimFormOverview'
import ClaimFormSync from '../../../../../../../../../components/authorised/order/edit/ClaimFormSync'
import Alert from '../../../../../../../../../itrust_common/components/Alert'
import { visionInsuranceClaimFormEdit, visionInsuranceClaimFormUpdate } from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'
import DateFormatView from '../../../../../../../../../itrust_common/components/others/DateFormatView'

function EyeMedClaimForm(props) {
  const { visionInsuranceConfig, order, handleSubmit, editing, visionInsuranceClaimForm, claimFormTemplate } = props
  const dispatch = useDispatch()
  let filters = {}

  useEffect(() => {
    if (visionInsuranceClaimForm.billing?.claim_data?.charges?.length) {
      dispatch(visionInsuranceClaimFormEdit({ formView: 'overview' }))
    }
    else {
      dispatch(visionInsuranceClaimFormEdit({ formView: 'form' }))
    }
  }, [visionInsuranceClaimForm.billing?.claim_data?.charges])

  const getActiveModuleArr = (res) => {
    return res.eligibility.data.map(item => item.active && item.service_type ? item.service_type : '')
  }

  const getActiveModule = (res) => {
    const activeModulesArr = getActiveModuleArr(res)
    if (activeModulesArr.includes('Exam')) {
      return 'Exam'
    }
    else if (activeModulesArr.includes("Contact Lens Fit and Follow-up")) {
      return "Contact Lens Fit and Follow-up"
    }
  }

  const getActiveTabModule = (res) => {
    const { activeTab, activeModule } = editing;
    res = res ?? visionInsuranceClaimForm
    const activeModulesArr = getActiveModuleArr(res)
    switch (activeTab) {
      case 'first':
        dispatch(visionInsuranceClaimFormEdit({ activeTab: 2, activeModule: getActiveModule(res) }));
        break;
      case 2:
        if (activeModule === 'Exam') {
          if (res.exams.exam?.is_cpt2_selected == 'no') {
            const newTab = activeModulesArr.includes("Contact Lens Fit and Follow-up") ? { activeTab: 2, activeModule: 'Contact Lens Fit and Follow-up' } : { activeTab: 'final', activeModule: '' };
            dispatch(visionInsuranceClaimFormEdit(newTab));
          }
          else {
            dispatch(visionInsuranceClaimFormEdit({ activeTab: 3, activeModule: 'Exam' }));
          }
        } else if (activeModule === 'Contact Lens Fit and Follow-up') {
          dispatch(visionInsuranceClaimFormEdit({ activeTab: 'final', activeModule: '' }));
        }
        break;
      case 3:
        if (activeModule === 'Exam') {
          const newTab = activeModulesArr.includes("Contact Lens Fit and Follow-up") ? { activeTab: 2, activeModule: 'Contact Lens Fit and Follow-up' } : { activeTab: 'final', activeModule: '' };
          dispatch(visionInsuranceClaimFormEdit(newTab));
        }
        break;
      case 'final':
        dispatch(visionInsuranceClaimFormEdit({ activeTab: '', activeModule: '' }));
        dispatch(visionInsuranceClaimFormEdit({ formView: 'overview' }))
        break;
      default:
        break;
    }
  };

  const computeData = (data) => {
    const filterActive = (items) => Array.isArray(items) ? items.filter(item => item.active) : items;
    const { exams } = data;
    if (exams) {
      //  filter each exam field is checked
      exams.exam && Object.keys(exams.exam).forEach(field => {
        if (exams.exam[field]) {
          exams.exam[field] = filterActive(exams.exam[field]);
        }
      });
      // filter each impression field is checked
      exams.impression && Object.keys(exams.impression).forEach(field => {
        if (exams.impression[field]) {
          exams.impression[field]['selected_value'] = filterActive(exams.impression[field]['selected_value']);
          exams.impression[field]['cpt_codes'] = filterActive(exams.impression[field]['cpt_codes']);
        }
      });
    }
    else {
      return { ...data, exams: { exam: {}, impression: {} }, contact_lens_fit_and_follow_up: {} }
    }
    return data;
  };

  const validateFormData = (data) => {
    const isAnyModuleSelected = data.eligibility?.data.find(item => item.active)
    // validate final step billing amount
    let chargesValidateArr = data.claim_data?.charges?.map(item => Number(item.charge))
    const hasNaN = chargesValidateArr ? (chargesValidateArr.find(item => Number.isNaN(item)) !== undefined) : false
    if (!isAnyModuleSelected) {
      Alert.warning('Please select a service to proceed.')
      return false
    }
    if (hasNaN) {
      Alert.warning('Invalid Amount')
      return false
    }
    return true
  }

  const getFilters = (data) => {
    const { activeTab, activeModule } = editing;
    const activeModulesArr = getActiveModuleArr(visionInsuranceClaimForm)
    switch (activeTab) {
      case 'first':
        return { claim_sections: ['eligibility'] }
      case 'final':
        return { claim_sections: ['charges'] }
      case 2:
        if (activeModule === 'Exam') {
          if (data.exams?.exam?.is_cpt2_selected === 'no' && !activeModulesArr.includes("Contact Lens Fit and Follow-up")) {
            return { claim_sections: ['exams', 'billing'] }
          }
          else {
            return { claim_sections: ['exams'] }
          }
        } else if (activeModule === 'Contact Lens Fit and Follow-up') {
          return { claim_sections: ['contact_lens_fit_and_follow_up', 'billing'] }
        }
        break;
      case 3:
        if (activeModule === 'Exam') {
          if (activeModulesArr.includes("Contact Lens Fit and Follow-up")) {
            return { claim_sections: ['impression'] }
          }
          else {
            return { claim_sections: ['impression', 'billing'] }
          }
        }
        break;
      default:
        return {}
    }
  }

  const handleClaimFormUpdate = async (data) => {
    data = computeData(data)
    const isFormValid = validateFormData(data)
    filters = getFilters(data)
    if (isFormValid) {
      let res = await dispatch(visionInsuranceClaimFormUpdate(data, filters))
      res = res.value.data.insurance_claim_form
      getActiveTabModule(res)
      filters = {}
    }
    return
  }

  const handleSyncSuccessfully = () => {
    dispatch(visionInsuranceClaimFormEdit({ activeTab: 'first', activeModule: '', formView: 'form' }));
  }

  return (
    <div className='mx-10 px-6'>
      {order.insurance_payer_changed && <h5 className='text-danger mb-5 text-center'>The insurance payer name is changed for the selected insurance.</h5>}
      <div className='d-flex justify-content-between align-items-center'>
        <div>
          {visionInsuranceConfig?.visible && order.vision_insurance_claim_exist && <RpaClaimSubmitButton order={order} />}
          {editing.formView !== 'overview' &&
            <button className='btn btn-outline-primary' onClick={() => dispatch(visionInsuranceClaimFormEdit({ formView: 'overview' }))}>Overview</button>
          }
          {order.claim_submission_at && <span className='text-danger ml-6'>Previous Claim Send on <DateFormatView dateTime={order.claim_submission_at} />
          </span>}
        </div>
        <div className='d-flex'>
          {/* <ClaimFormDownload /> */}
          <ClaimFormSync label="Reset" handleAfterSyncSuccessfully={handleSyncSuccessfully} />
        </div>
      </div>
      {editing.formView == 'overview' ?
        <ClaimFormOverview visionInsuranceClaimForm={visionInsuranceClaimForm} claimFormTemplate={claimFormTemplate} /> :
        <form onSubmit={handleSubmit(handleClaimFormUpdate)}>
          <EyeMedStepForm pprops={{ ...props }} />
        </form>
      }
    </div>
  )
}

EyeMedClaimForm = reduxForm({
  form: 'EyeMedClaimForm',
  enableReinitialize: true,
  shouldValidate: () => true,
  onSubmitFail: () => ScrollToTarget()
})(EyeMedClaimForm)

const mapStateToProps = (state) => {
  const { organisation: { organisation }, order: { order }, visionInsuranceClaimForm: { visionInsuranceClaimForm, saving, editing } } = state

  return {
    visionInsuranceConfig:organisation.add_ons_config?.type?.vision_insurance,
    order,
    visionInsuranceClaimForm,
    editing,
    saving,
    initialValues: {
      ...visionInsuranceClaimForm,
    }
  }
}

export default connect(mapStateToProps)(EyeMedClaimForm)